import Notification from '../core/Notification';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import LiteralConfirmationField from '../core/LiteralConfirmationField';
import withGS from '../core/withGShoc';
import { globalStyles } from '../core/style/gstheme';
import { computeDatatype } from '../core/utils/utils';

const styles = () => {
  return Object.assign({
    instruction: {
      color: '#000000',
      marginBottom: 6
    }
  }, globalStyles);
};

class DatatypeConstraintHandler extends React.Component {

  onUpdate = (property) => (value) => this.props.onUpdate(property, value);

  render() {

    const { data, id, graph, classes, onDelete } = this.props;
    const isReadOnly = this.props.isReadOnly || data.pendingDeletion;

    let label = undefined;
    let propName = undefined;
    if ("minInclusive" in data) {
      label = "Minimum Inclusive";
      propName = "minInclusive";
    }
    else if ("maxInclusive" in data) {
      label = "Maximum Inclusive";
      propName = "maxInclusive";
    }
    else if ("minExclusive" in data) {
      label = "Minimum Exclusive";
      propName = "minExclusive";
    }
    else if ("maxExclusive" in data) {
      label = "Maximum Exclusive";
      propName = "maxExclusive";
    }
    else if ("minLength" in data) {
      label = "Minimum Length";
      propName = "minLength";
    }
    else if ("maxLength" in data) {
      label = "Maximum Length";
      propName = "maxLength";
    }
    else if ("length" in data) {
      label = "Length";
      propName = "length";
    }
    else if ("pattern" in data) {
      label = "Pattern";
      propName = "pattern";
    }
    else if ("rdfLangRange" in data) {
      label = "Language Range";
      propName = "rdfLangRange";
    }

    const valueText = propName ?
      data[propName]["@value"] || data[propName]
      :
      undefined;
    const datatype = propName ?
      data[propName].type ?
        data[propName].type
        :
        computeDatatype(data[propName])
      :
      undefined;

    if (data.pendingDeletion) return null;

    return (
      <div
        data-test="constraint-detail"
        className={classes.completeData}
        style={{ marginBottom: 6 }}
      >
        {data.pendingDeletion &&
          <Notification error={true} text="This constraint is pending deletion." dataTest="pending-deletion" />
        }
        <div>
          {!isReadOnly &&
            <Tooltip title='Delete constraint'>
              <span style={{ float: 'right', marginBottom: 6 }}>
                <Typography variant="body2">
                  <IconButton data-test="delete-constraint" size="small" onClick={onDelete} className={classes.deleteButton}>
                    <DeleteIcon />
                  </IconButton>
                </Typography>
              </span>
            </Tooltip>
          }
          <Typography variant="caption" className={classes.instruction} data-test="with-constraint-label">{label}</Typography>
          {propName === "rdfLangRange" &&
            <div style={{ marginTop: 12 }}>
              <Notification text="Language ranges are currently only supported for display purposes." dataTest="langrange-warning" />
            </div>
          }
          <LiteralConfirmationField
            dataTest="constraint-value"
            graph={graph}
            displayDatatype={true}
            source={id}
            property={propName}
            margin="dense"
            onUpdate={this.onUpdate(propName)}
            text={valueText.toString()}
            datatype={datatype}
            canBeDeleted={false}
            isReadOnly={isReadOnly || propName === "rdfLangRange"}
          />
        </div>
      </div>
    );
  }
}

DatatypeConstraintHandler.propTypes = {
  id: PropTypes.string,
  data: PropTypes.object,
  graph: PropTypes.string,
  onDelete: PropTypes.func.isRequired,
  projectIRI: PropTypes.string.isRequired,
  isReadOnly: PropTypes.bool
};

export default withStyles(styles)(withGS(DatatypeConstraintHandler));